module.exports = __webpack_public_path__ + "media/images/birthday-98dd7fb5413cd9fc31e458ace7ec1dea.png";